import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import VueMarkdown from 'vue-markdown';
import Loading from '@/components/Loading.vue';
import ImageWithLoading from '@/components/ImageWithLoading.vue';
import { map, chunk } from 'lodash';
let CharactersSpeciesDetailHalfHuman = class CharactersSpeciesDetailHalfHuman extends Vue {
    get tableChunks() {
        const numChunks = {
            xs: 1,
            sm: 2,
            md: 4,
            lg: 4,
            xl: 4
        }[this.$vuetify.breakpoint.name];
        const entriesArray = map(this.speciesData.halfHumanTableEntries, (trait, species) => ({ trait, species }));
        const chunkSize = Math.ceil(entriesArray.length / numChunks);
        return chunk(entriesArray, chunkSize);
    }
    get correctedText() {
        return this.speciesData.flavorText.replace('Half-Human table above', 'Half-Human table below');
    }
};
__decorate([
    Prop(Object)
], CharactersSpeciesDetailHalfHuman.prototype, "speciesData", void 0);
CharactersSpeciesDetailHalfHuman = __decorate([
    Component({
        components: {
            VueMarkdown,
            Loading,
            ImageWithLoading
        }
    })
], CharactersSpeciesDetailHalfHuman);
export default CharactersSpeciesDetailHalfHuman;
